import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="page contact-page">
      <Helmet>
        <title>İletişim | KAIN Watches Ankara — Lüks Saat Satış &amp; Alış</title>
        <meta
          name="description"
          content="Ankara lüks saat satış ve alış için KAIN Watches ile iletişim. Rolex ve seçkin markalar, WhatsApp, telefon."
        />
        <link rel="canonical" href="https://kainsaat.com/contact" />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {t('navbar.contact')}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Bu sayfa yapım aşamasındadır.
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 